import React from 'react';
import {
    StyledIcon,
    StyledInsuranceCategory,
    StyledInsuranceImage,
    StyledInsuranceName,
    StyledInsuranceNameContainer,
    StyledNameContainer,
    StyledDetailsContainer
} from './styles';
import { ChevronDownIcon, DefaultInsuranceIcon } from '../../../assets/img';
import { IInsuranceIdentity } from './types';
import { getPolicyTitle } from '../../../utils/PolicyServices';

const InsuranceIdentity: React.FunctionComponent<IInsuranceIdentity> = ({
    policyCategory,
    policyImage,
    policyName,
    familyStructure,
    onIconClick,
    isInverted = false,
    isPhoneResponsive = false
}) => {
    return (
        <StyledNameContainer data-testid="insurance-identity-name-container">
            <StyledDetailsContainer $isPhoneResponsive={isPhoneResponsive}>
                <StyledInsuranceImage
                    src={policyImage || DefaultInsuranceIcon}
                    alt={'Insurance Image'}
                    data-testid="insurance-identity-image"
                />
                <StyledInsuranceNameContainer $isPhoneResponsive={isPhoneResponsive}>
                    <StyledInsuranceName data-testid="insurance-identity-name">
                        {getPolicyTitle(policyCategory, familyStructure)}
                    </StyledInsuranceName>
                    <StyledInsuranceCategory data-testid="insurance-identity-category">
                        {policyName}
                    </StyledInsuranceCategory>
                </StyledInsuranceNameContainer>
            </StyledDetailsContainer>
            {onIconClick ? (
                <StyledIcon
                    src={ChevronDownIcon}
                    alt={'Chevron-Down'}
                    onClick={onIconClick}
                    $isInverted={isInverted}
                    data-testid="insurance-identity-chevron-icon"
                />
            ) : null}
        </StyledNameContainer>
    );
};

export default InsuranceIdentity;
